import { useEffect, useRef, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE, MASK_NUMBER, MASK_TEXT_NOWRAP } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { _FixedAssetItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { AssetItemHistory } from "./AssetItemHistory/AssetItemHistory";
import { FixedAssetItemDepreciation } from "./AssetDepreciationType/FixedAssetItemDepreciation";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { FixedAssetItemRevaluation } from "./FixedAssetItemRevaluation/FixedAssetItemRevaluation";
import { FixedAssetItemDevaluation } from "./FixedAssetItemDevaluation/FixedAssetItemDevaluation";
import { FixedAssetItemDeterioration } from "./FixedAssetItemDeterioration/FixedAssetItemDeterioration";
import { FixedAssetItemAddition } from "./FixedAssetItemAddition/FixedAssetItemAddition";
import { FixedAssetActiveHistoryByFixed } from "./FixedAssetActiveHistoryByFixed/FixedAssetActiveHistoryByFixed";
import { SelectFixedAsset } from "./FixedAsset/SelectFixedAsset";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { _BusinessProcess, _FixedAssetExtraData, _RequestMaintenance, _single, _SystemPropertyOB, _WorkMaintenanceOrder } from "../../../../../../core/services/dataBean/EntityCatalog";
import { FixedAssetItemStatesForDownloadItems } from "./FixedAssetitemStatesForDownloaditems";
import { SelectFunctionalID } from "../../../../../admin/configuracion/functionalID/SelectFunctionalID";
import { SelectBusinessCore } from "../../../../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";
import { EditorCostingCenter } from "../../../../../erp/cellEditor/CostingCenter/EditorCostingCenter";
import { FixedAssetStateConstants } from "./FixedStateConstants";
import { RequestMaintenance } from "../../../../../Factoty&Production/Maintenance/RequestMaintenance/RequestMaintenance";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM, MODAL_XL } from "../../../../../theme/Component/hooks/useModal";
import { AssignedMaintenanceType } from "./AssignedMaintenanceType/AssignedMaintenanceType";
import { FileInput } from "../../../../../theme/Component/FileInput";
import { SelectSiteID } from "../../../../../admin/configuracion/SiteID/SelectSiteID";
import { SelectFixedAssetOperationalStateConstants } from "./Selectores/SelectFixedAssetOperationalStateConstants";
import { SelectorUmeasurement } from "../../../../../bpm/config/Componentes/SelectorUmeasurement";
import { FixedAssetReplacement } from "./FixedAssetReplacement/FixedAssetReplacement";
import { WorkMaintenanceOrderByItem } from "./WorkMaintenanceOrder/WorkMaintenanceOrderByItem";
import { SelectLocationMaintenance } from "../../../../../Factoty&Production/Maintenance/LocationMaintenance/SelectLocationMaintenance";
import { InputHours } from "../../../../../theme/Input/InputHours";
import usePaginator from "../../../../../theme/Component/usePaginator";
import { FixedAssetImages } from "./FixedAssetImages/FixedAssetImages";
import { FixedAssetExtraData } from "./FixedAssetExtraData/FixedAssetExtraData";
import { DropDown } from "../../../../../theme/Component/DropDown";
import "./FixedAssetItem.css"
import { SelectFixedAssetGroups } from "./FixedAssetGroups/SelectFixedAssetGroups";
import { SelectStoreEditor } from "../SelectStore.editor";
import { ExportXLSL } from "../../../../../theme/Component/ExportXLSX";
import { EditorShelfInventory } from "../../../../../Inventories-Warehouses/inventory.Store/ShelfInventory/EditorShelfInventory";

type filterProps = {
    IDFixedAsset: number;
    IDStore: number;
    State: number[];
    TicketCode: number;
    IDAccount: number;
}

interface Props {
    isModal?: boolean;
    onChange?: (value: string) => void;
    preFilterProps?: Partial<filterProps>;
}

export const FixedAssetItem = ({ isModal, onChange, preFilterProps }: Props) => {

    const { instance, lista, setLista, bean, setBean, update, deleteItemVoid, handleChange } = useDataBean(_FixedAssetItem);
    const { instance: EDInstance, bean: beanED, setBean: setBeanED } = useDataBean(_FixedAssetExtraData)
    const propertie = useDataBean(_SystemPropertyOB)


    const paginador = usePaginator();

    const [regexStr, setregexStr] = useState<any>(null)
    const [form, setform] = useState<Partial<filterProps>>(preFilterProps ?? {});

    const [excelProps, setExcelProps] = useState<any>({});
    const [mostrarBotonesControlado, setMostrarBotonesControlado] = useState(false);

    const [agregarresp, setAgregarresp] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [retiraractivo, setRetiraractivo] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalactivos, setModalActivos] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modaldeterioro, setModaldeterioro] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modaldevaluaciones, setModaldevaluaciones] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modaladiciones, setModaladiciones] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalrevalorizaciones, setModalrevalorizaciones] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalhistorial, setModalhistorial] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modaldepreciaciones, setModaldepreciaciones] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modaleditar, setModaleditar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-sm' });
    const modalHistory = useModal(`Historial de mantenimiento de ${bean.Description}`, MODAL_XL);
    const modalMaintenaceType = useModal(`Tipo de Mantenimientos de ${bean.Name}`, MODAL_md);
    const modalReplacement = useModal(`Catalogo de Repuestos Realizados de ${bean.Name}`, MODAL_md);
    const modalWorkMaintenance = useModal(`Mantenimientos Relizados de ${bean.Name}`, MODAL_md);
    const modalListImages = useModal(`Listado de imagenes de ${bean.Name}`, MODAL_LG);
    const modalExtraData = useModal(`Datos Adicionales de ${bean.Name}`, MODAL_LG);
    const modalImportExtraData = useModal(`Importar Datos Extra`, MODAL_md);
    const modalUdatePlacas = useModal(`Actualizar Placas de Activos Fijos`, MODAL_md);

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        instance.getFixedAssetItemsByFilterTicket(form.IDFixedAsset, regexStr, form.IDAccount, form.IDStore, form.State, form.TicketCode, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    resp.List.forEach(element => {
                        const item = element.DataBeanProperties;
                        item.DimensionesEntity = `${item.DimWidth & item.DimHeigth ? `${item.DimWidth} x ${item.DimHeigth}` : "N/A"}`
                        item.ResolveCode = item.LineCode ? `${item.LineCode} - ${item.TicketCode}` : item.TicketCode;
                    });
                    const tieneControlado = resp.List.some((item: any) => item.Checked === true);
                    setMostrarBotonesControlado(tieneControlado);
                    setLista(resp.List)
                }
            }
        )
    }
    const addFixedAssetitemToControlled = () => {

        instance.addFixedAssetitemToControlled(bean.IDItem, bean.from, bean.IDResponsible, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {

                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const removeFixedAssetitemToControlled = () => {

        instance.removeFixedAssetitemToControlled(bean.IDItem, bean.from, bean.itemDownCase, bean.observations, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {

                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const deleteItem = () => {
        deleteItemVoid(bean.IDItem).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        if (bean.UseShelfInventory && !bean.IDShelfInventory) {
            toast.error("Debe Seleccionar una Estanteria/Ubicación Fisica")
            return;
        }
        update().then(
            (resp: any) => {
                getLista();
                setModaleditar({ ...modaleditar, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDItem', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Fecha Evento', property: 'InitDate', visible: true },
        { title: 'Placa', property: 'ResolveCode', visible: true, mask: MASK_TEXT_NOWRAP },
        { title: 'Disponibilidad', property: 'StateName', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Responsable', property: 'ResponsibleName', visible: true },
        { title: 'Línea/Grupo de Activos', property: 'FixedAssetLineName', visible: true },
        { title: 'Ubicación Geografica', property: 'SiteIDName', visible: true },
        { title: 'Ubicación', property: 'StoreName', visible: true },
        { title: 'Usa Estanteria/Ubicación Fisica', property: 'UseShelfInventory', visible: true },
        { title: 'Estado del Bien', property: 'FixedAssetStateName', visible: true },
        { title: 'Serial', property: 'SerialNumber', visible: true },
        { title: 'Estado Operativo', property: 'OperationalStateName', visible: true },
        { title: 'Modelo de Fabricante', property: 'SupplierModel', visible: true },
        { title: 'Código Interno Referencia', property: 'InternalCode', visible: true },
        { title: 'Dimensiones', property: 'DimensionesEntity', visible: true },
        { title: 'Unidad Medida de Dimensiones', property: 'LengthMeasurementUnitName', visible: true },
        { title: 'Peso', property: 'DimWeight', visible: true },
        { title: 'Unidad Medida de Peso', property: 'WeightMeasurementUnitName', visible: true },
        { title: 'Area de Mantenimiento', property: 'LocationMaintenanceName', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Numero Documento', property: 'Consecutive', visible: true },
        { title: 'Controlado', property: 'Checked', visible: true },
        { title: 'Cuentas de Orden', property: 'OrderAccountant', visible: true },
        { title: 'Causa de la Baja', property: 'ItemDownCauseName', visible: true },
        { title: 'Tiempo Depreciación', property: 'DepreciationTime', visible: true },
        { title: 'Tiempo Depreciación Fiscal', property: 'FiscalDepreciationTime', visible: true },
        { title: 'Adición NIIF', property: 'NiifAdditionValue', visible: true },
        { title: 'Adición Fiscal', property: 'FiscalAdditionValue', visible: true },
        { title: 'Dependencia', property: 'IDLnFunctionalID', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterCode', visible: true },
        { title: 'Unidad de Negocio', property: 'BusinessCoreName', visible: true },
        { title: 'Reconocimiento NIIF Inicial', property: 'NiifInitialValue', visible: true },
        { title: 'Valor Residual', property: 'ResidualValue', visible: true },
        { title: 'Usar Cuenta Servicio en Ops NIIF', property: 'UseBrandIDForAllOps', visible: true },
        { title: 'Responsable 1 Turno', property: 'IDResponsible2', visible: true },
        { title: 'Responsable 2 Turno', property: 'IDResponsible3', visible: true },
        { title: 'No Póliza Seguro', property: 'SecurityPolicyID', visible: true },
        { title: 'Vencimiento Póliza Seguro', property: 'SecurityPolicyDefeat', visible: true, mask: MASK_DATE },
        { title: 'Último Avalúo', property: 'LastAppraisal', visible: true, mask: MASK_DATE },
        { title: 'Última Valorazión', property: 'LastValuation', visible: true, mask: MASK_DATE },
        { title: 'Observaciones', property: 'Observations', visible: true },
    ]


    // const iconButtonsItem = [
    //     { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    // ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModaleditar({ ...modaleditar, "view": true, name: "Editar" }) } },
            { titulo: 'Datos Adicionales', icono: 'ri-attachment-line', visible: _single.canEdit(), evento: () => { modalExtraData.open(); } },
            { titulo: 'Consultar Historial de Item de Activo Fijo', icono: 'ri-folder-4-line', visible: _single.canEdit(), evento: () => { setModalhistorial({ ...modalhistorial, "name": `Historial`, "view": true }) } },
            { titulo: 'Consultar Depreciaciones', icono: 'ri-file-history-line', visible: _single.canEdit(), evento: () => { setModaldepreciaciones({ ...modaldepreciaciones, "name": `Depreciaciones`, "view": true }) } },
            { titulo: 'Consulta Revalorizaciones', icono: 'ri-folder-chart-line', visible: _single.canEdit(), evento: () => { setModalrevalorizaciones({ ...modalrevalorizaciones, "name": `Revalorizaciones`, "view": true }) } },
            { titulo: 'Consultar Devaluaciones', icono: 'ri-folder-reduce-line', visible: _single.canEdit(), evento: () => { setModaldevaluaciones({ ...modaldevaluaciones, "name": `Devaluaciones`, "view": true }) } },
            { titulo: 'Consultar Deterioros', icono: 'ri-folder-download-line', visible: _single.canEdit(), evento: () => { setModaldeterioro({ ...modaldeterioro, "name": `Deterioros`, "view": true }) } },
            { titulo: 'Consultar Adiciones', icono: 'ri-folder-add-line', visible: _single.canEdit(), evento: () => { setModaladiciones({ ...modaladiciones, "name": `Adiciones`, "view": true }) } },
            { titulo: 'Consultar Cambios de Grupo de Activos', icono: 'ri-folder-chart-2-line', visible: _single.canEdit(), evento: () => { setModalActivos({ ...modalactivos, "name": `Activos`, "view": true }) } },
            // { titulo: 'Solicitar Mantenimiento', icono: 'ri-settings-5-fill', visible: bean.OperationalState == 34, evento: () => { setRequest({}); modalRequest.open() } },
            { titulo: 'Historial de Procedimientos', icono: 'ri-history-line', visible: true, evento: () => { modalHistory.open() } },
            { titulo: 'Listado de Imagenes', icono: 'ri-camera-lens-line', visible: _single.canView(), evento: () => { modalListImages.open(`Listado de Imagenes de ${bean.Name}`) } },
            { titulo: 'Tipos de Mantenimiemtos', icono: 'ri-file-settings-line', visible: true, evento: () => { modalMaintenaceType.open() } },
            { titulo: 'Consultar Catalogo de Repuestos Realizados', icono: 'ri-file-settings-line', visible: true, evento: () => { modalReplacement.open() } },
            { titulo: 'Consultar Mantenimientos Relizados', icono: 'ri-file-settings-line', visible: true, evento: () => { modalWorkMaintenance.open() } },
        ];

        if (mostrarBotonesControlado) {
            botones.push(
                {
                    titulo: 'Agregar/Cambiar Responsable de Activo Controlado',
                    icono: 'ri-edit-2-line',
                    visible: _single.canEdit(),
                    evento: () => { setAgregarresp({ ...agregarresp, "name": `Agregar`, "view": true }) }
                },
                {
                    titulo: 'Retirar Activo Fijo de Controlado',
                    icono: 'ri-edit-2-line',
                    visible: _single.canEdit(),
                    evento: () => { setRetiraractivo({ ...retiraractivo, "name": `Retirar`, "view": true }) }
                }
            );
        }

        return <ListMenu listaBotones={botones} />;
    };

    const [listaExport, setListaExport] = useState<any[]>([]);
    const modalCSV = useModal("Exportar Datos", MODAL_SM);

    const getListaExport = () => {
        instance.getFixedAssetItemsByFilterTicket(form.IDFixedAsset, regexStr, form.IDAccount, form.IDStore, form.State, form.TicketCode, 1, paginador.pages * 15).then(
            (resp: any) => {
                if (resp) {
                    modalCSV.open()
                    resp.List.forEach(element => {
                        const item = element.DataBeanProperties;
                        item.DimensionesEntity = `${item.DimWidth & item.DimHeigth ? `${item.DimWidth} x ${item.DimHeigth}` : "N/A"}`
                    });
                    setListaExport(resp.List)
                }
            }
        )
    }
    const exportItems = () => {

        toast.success("Exportando elementos el link de descarga esta en la bandeja de mensajes");
        instance.exportFixedAssetsItem(_single.getAccountID(), form.IDStore).then(
            (resp: any) => {
                _single.printOut(resp);
            }
        )

    }



    const actionsDropDown = [
        { id: 1, name: 'Importar Datos Adicionales', permiso: null, activo: true },
        { id: 2, name: 'Actualizar Placas/Estado de Activos', permiso: _single.canCreate(), activo: true },
        { id: 3, name: 'Exportar Items', permiso: _single.canExport(), activo: true },
        // { id: 4, name: 'Exportar', permiso: null, activo: true },
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id === 1) {
                            setBeanED({});
                            modalImportExtraData.open();
                        } else if (e.id === 2) {
                            setBeanED({});
                            modalUdatePlacas.open();
                        } else if (e.id === 3) {
                            exportItems();
                        } else if (e.id === 4) {
                            getListaExport();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }

    const importExtraData = () => {
        EDInstance.importFixedAssetsExtraData(_single.getAccountID(), beanED.Media, beanED.MediaContext).then(
            (resp) => {
                toast.success("Importacion Finalizada");
                modalImportExtraData.close();
            }
        ).catch(
            err => {
                toast.error("No se pudo realizar la acción")
            }
        )
    }

    const updatePlatesImport = () => {
        instance.updateFixedAssetsItemByTicketCode(_single.getAccountID(), beanED.Media, beanED.MediaContext).then(
            (resp) => {
                toast.success("Actualización Finalizada");
                modalUdatePlacas.close();
                getLista();
            }
        ).catch(err => { toast.error(err) })
        //beanED.Media, beanED.MediaContext
    }

    const getImportDataExcel = () => {


        propertie.instance.getSystemProperty("CUSTOM_FORM_FIXED_ASSET_ITEM").then(
            (resp) => {
                if (resp.SystemValue) {

                    EDInstance.getFixedAssetsItemsProps(_single.getAccountID(), resp.SystemValue).then(
                        (resp) => {
                            console.log(resp)
                            setExcelProps(resp)
                        }
                    ).catch(err => { toast.error(err) })
                } else {
                    toast.error("no se pudo cargar la informacion adicional")
                }
            }
        ).catch(err => { console.log(err) });




    }

    useEffect(() => {
        if (modalImportExtraData.modal.view === true) {
            getImportDataExcel();
        }
    }, [modalImportExtraData.modal.view])

    const setRowBean = (obj: any) => {
        setBean(obj)
        onChange?.(obj)
    }

    const bodyComponennt = () => {
        return (
            <div className="row">

                {preFilterProps?.IDFixedAsset ? null :
                    <div className="col-md-4">
                        <label>Activo Fijo</label>
                        <SelectFixedAsset idSelector={form.IDFixedAsset} onChange={(e) => { setform({ ...form, IDFixedAsset: e.IDFixedAsset }) }} label=" " returnType="Object" />
                    </div>
                }
                <div className="col-md-4">
                    <label>Búsqueda por Texto</label>
                    <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>

                {preFilterProps?.IDAccount ? null :
                    <div className="col-md-4">
                        <AccountEditor idAccount={form.IDAccount} onChange={(e: any) => { setform({ ...form, IDAccount: e.IDAccount }) }} label="Responsable" />
                    </div>
                }
                {preFilterProps?.IDStore ? null :
                    <div className="col-md-4">
                        <SelectStoreEditor idSelector={form.IDStore} label="Almacén/Bodega" onChange={(e) => { setform({ ...form, IDStore: e.IDStore }) }} />
                    </div>
                }
                {preFilterProps?.TicketCode ? null :
                    <div className="col-md-4">
                        <label>Placa</label>
                        <input type="text" name="ticketCode" className="form-control" value={form.TicketCode} onChange={(e) => {
                            const valor = e.target.value ? Number(e.target.value) : null;
                            setform({ ...form, TicketCode: valor })
                        }} />
                    </div>
                }
                <div className="col-md-4 mt-3 p-3">
                    <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={getLista}>Buscar</BasicButton>
                </div>

                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} body={lista} head={head} rowSet={setRowBean} listButtons={listaBotones()} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modaleditar} updateModal={setModaleditar} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <FileInput
                                    label="Imagen"
                                    previsualization
                                    Media={bean.Media}
                                    MediaContext={bean.MediaContext}
                                    docAcept="image/jpeg, image/png, image/gif, image/bmp, image/tiff, image/svg+xml"
                                    onCreate={(e) => { setBean({ ...bean, Media: e.Media, MediaContext: e.MediaContext }) }}
                                />
                            </div>
                            <div className="col-md-6">
                                <SelectFunctionalID label='Dependencia' functionalIDLn={bean.IDLnFunctionalID} onChange={(e: any) => { setBean({ ...bean, "IDLnFunctionalID": e.IDLn }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectFixedAssetGroups idSelector={bean.IDFixedAssetGroups} onChange={(e) => { setBean({ ...bean, IDFixedAssetGroups: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Centro de Costo</label>
                                <EditorCostingCenter render={bean.CostingCenterCode} idSelector={bean.CostingCenterCode} onChange={(e) => { setBean({ ...bean, "CostingCenterCode": e.Code, "CostingCenterCodeName": e.Code }) }} label=" " returnType="Object" />
                                {/* <CostingCenterSelect label="Centro de Costo" idSelector={bean.CostingCenterCodeName} onChange={(e) => { setBean({ ...bean, "CostingCenterCode": e }) }} /> */}
                            </div>
                            <div className="col-md-6">
                                <FixedAssetItemStatesForDownloadItems idSelector={bean.ItemDownCause} onChange={(acc: any) => { setBean({ ...bean, "ItemDownCause": acc }); }} />
                            </div>
                            <div className="col-md-6">
                                <FixedAssetStateConstants idSelector={bean.FixedAssetState} onChange={(e: any) => { setBean({ ...bean, "FixedAssetState": e }); }} />
                            </div>
                            {/* <div className="col-md-6">
                                <SelectBusinessCore label="Unidad de Negocio" idSelector={bean.IDBusinessCore} onChange={(e) => { setBean({ ...bean, "IDBusinessCore": e }) }} />
                            </div> */}
                            <div className="col-md-6">
                                <label>Serial</label>
                                <input type="text" name='SerialNumber' className='form-control' value={bean.SerialNumber} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Tiempo Depreciación</label>
                                <input type="text" name='DepreciationTime' className='form-control' value={bean.DepreciationTime} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Tiempo Depreciación Fiscal</label>
                                <input type="text" name='FiscalDepreciationTime' className='form-control' value={bean.FiscalDepreciationTime} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Adición NIIF</label>
                                <input type="text" name='NiifAdditionValue' className='form-control' value={bean.NiifAdditionValue} onChange={handleChange} />
                            </div>

                            <div className="col-md-6">
                                <label>Adición Fiscal</label>
                                <input type="text" name='FiscalAdditionValue' className='form-control' value={bean.FiscalAdditionValue} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Reconocimiento NIIF Inicial</label>
                                <input type="text" name='NiifInitialValue' className='form-control' value={bean.NiifInitialValue} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Valor Residual</label>
                                <input type="text" name='ResidualValue' className='form-control' value={bean.ResidualValue} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Usar Cuenta Servicio en Ops NIIF" estado={bean.UseBrandIDForAllOps} eventChange={(e: any) => { setBean({ ...bean, "UseBrandIDForAllOps": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="No depreciar ni amortizar" estado={bean.NotDepreciateOrAmortize} eventChange={(e: any) => { setBean({ ...bean, "NotDepreciateOrAmortize": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <AccountEditor idAccount={bean.IDResponsible2} label="Responsable 1 Turno" onChange={(e) => { setBean({ ...bean, IDResponsible2: e.IDAccount }) }} />
                            </div>
                            <div className="col-md-6">
                                <AccountEditor idAccount={bean.IDResponsible3} label="Responsable 2 Turno" onChange={(e) => { setBean({ ...bean, IDResponsible3: e.IDAccount }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>No Póliza Seguro</label>
                                <input type="text" className="form-control" value={bean.SecurityPolicyID} onChange={(e) => { setBean({ ...bean, SecurityPolicyID: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="SecurityPolicyDefeat" value={bean.SecurityPolicyDefeat} setDate={(e) => { setBean({ ...bean, SecurityPolicyDefeat: e }) }} label="Vencimiento Póliza Seguro" />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="LastAppraisal" value={bean.LastAppraisal} setDate={(e) => { setBean({ ...bean, LastAppraisal: e }) }} label="Último Avalúo" />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="LastValuation" value={bean.LastValuation} setDate={(e) => { setBean({ ...bean, LastValuation: e }) }} label="Última Valorazión" />
                            </div>

                            <div className="col-md-6">
                                <SelectFixedAssetOperationalStateConstants idSelector={bean.OperationalState} onChange={(e) => { setBean({ ...bean, OperationalState: e }) }} label="Estado Operativo" />
                            </div>
                            <div className="col-md-6">
                                <label>Código Interno de Referencia</label>
                                <input type="text" className="form-control" value={bean.InternalCode} onChange={(e) => { setBean({ ...bean, InternalCode: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Modelo Operativo</label>
                                <input type="text" className="form-control" value={bean.SupplierModel} onChange={(e) => { setBean({ ...bean, SupplierModel: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Utilizar Estanteria/Ubicación Fisica de almacen" estado={bean.UseShelfInventory} eventChange={(e) => { setBean({ ...bean, UseShelfInventory: e }) }} />
                            </div>
                            {bean.UseShelfInventory &&
                                <div className="col-md-6">
                                    <EditorShelfInventory idSelector={bean.IDShelfInventory} idStore={bean.IDStore} onChange={(e) => { setBean({ ...bean, IDShelfInventory: e.IDShelfInventory }) }} label="Estanteria/Ubicación Fisica" storeModify />
                                </div>
                            }
                            <div className="col-md-6">
                                <label>Dimensiones</label>
                                <div className="row">
                                    <div className="col-md-5">
                                        <input type="number" className="form-control" value={bean.DimWidth} onChange={(e) => {
                                            const value = e.target.value ? parseFloat(e.target.value) : null;
                                            setBean({ ...bean, DimWidth: value });
                                        }} />
                                    </div>
                                    <div className="col-md-2 d-flex align-content-center justify-content-center">x</div>
                                    <div className="col-md-5">
                                        <input type="number" className="form-control" value={bean.DimHeigth} onChange={(e) => {
                                            const value = e.target.value ? parseFloat(e.target.value) : null;
                                            setBean({ ...bean, DimHeigth: value });
                                        }} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <SelectorUmeasurement idSelector={bean.LengthMeasurementUnit} onChange={(e) => { setBean({ ...bean, LengthMeasurementUnit: e }) }} titulo="Unidad Medida de Dimensiones" />
                            </div>
                            <div className="col-md-6">
                                <label>Peso</label>
                                <input type="number" className="form-control" value={bean.DimWeight} onChange={(e) => {
                                    const value = e.target.value ? parseFloat(e.target.value) : null;
                                    setBean({ ...bean, DimWeight: value });
                                }} />
                            </div>
                            <div className="col-md-6">
                                <SelectorUmeasurement idSelector={bean.WeightMeasurementUnit} onChange={(e) => { setBean({ ...bean, WeightMeasurementUnit: e }) }} titulo="Unidad Medida de Peso" />
                            </div>
                            <div className="col-md-6">
                                <label>Ubicación Geográfica</label>
                                <SelectSiteID onChange={(e) => { setBean({ ...bean, IDLnSiteID: e.IDLn }) }} edit={false} idLnSite={bean.IDLnSiteID} />
                            </div>
                            <div className="col-md-6">
                                <SelectLocationMaintenance idSelector={bean.IDLocationMaintenance} onChange={(e) => { setBean({ ...bean, IDLocationMaintenance: e }) }} label="Area de Mantenimiento" />
                            </div>

                            <div className="col-md-6">
                                <InputHours _value={{ Hour: bean.HourInitTurn, Minute: bean.MinuteInitTurn }} onChange={(e) => {
                                    setBean({ ...bean, HourInitTurn: e.Hour, MinuteInitTurn: e.Minute })
                                }} _label="Inicio de Turno" />
                            </div>

                            <div className="col-md-6">
                                <InputHours _value={{ Hour: bean.HourUptoTurn, Minute: bean.MinuteUptoTurn }} onChange={(e) => {
                                    setBean({ ...bean, HourUptoTurn: e.Hour, MinuteUptoTurn: e.Minute })
                                }} _label="Fin de Turno" />
                            </div>

                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea name="Observations" className="form-control" value={bean.Observations} onChange={handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalhistorial} updateModal={setModalhistorial} eventModal={editaItem}>
                        <div className="row">
                            <AssetItemHistory idItem={bean.IDItem} />
                        </div>
                    </Modal>
                    <Modal modal={modalExtraData.modal} updateModal={modalExtraData.setModal}>
                        <FixedAssetExtraData IDFixedAssetItem={bean.IDItem} onCloseModal={() => { }} />
                    </Modal>
                    <Modal modal={modaldepreciaciones} updateModal={setModaldepreciaciones} eventModal={editaItem}>
                        <div className="row">
                            <FixedAssetItemDepreciation idItem={bean.IDItem} />
                        </div>
                    </Modal>
                    <Modal modal={modalrevalorizaciones} updateModal={setModalrevalorizaciones} eventModal={editaItem}>
                        <div className="row">
                            <FixedAssetItemRevaluation idItem={bean.IDItem} />
                        </div>
                    </Modal>
                    <Modal modal={modaldevaluaciones} updateModal={setModaldevaluaciones} eventModal={editaItem}>
                        <div className="row">
                            <FixedAssetItemDevaluation idItem={bean.IDItem} />
                        </div>
                    </Modal>
                    <Modal modal={modaldeterioro} updateModal={setModaldeterioro} eventModal={editaItem}>
                        <div className="row">
                            <FixedAssetItemDeterioration idItem={bean.IDItem} />
                        </div>
                    </Modal>
                    <Modal modal={modaladiciones} updateModal={setModaladiciones} eventModal={editaItem}>
                        <div className="row">
                            <FixedAssetItemAddition idItem={bean.IDItem} />
                        </div>
                    </Modal>

                    <Modal modal={modalImportExtraData.modal} updateModal={modalImportExtraData.setModal} eventModal={() => {
                        if (!beanED?.Media) {
                            toast.error("Archivo no valido")
                        } else {
                            importExtraData();
                        }
                    }}>
                        <div className="row">
                            <div className="excel-hint-simple">
                                <strong>Columnas permitidas para el Excel (la primera columna es el ID del Activo fijo):</strong>

                                {Object.keys(excelProps).length === 0 ? (
                                    <div className="excel-hint-empty">
                                        No hay columnas configuradas para importar.
                                    </div>
                                ) : (
                                    Object.entries(excelProps).map(([key, label]) => (
                                        <div key={key} className="excel-hint-row">
                                            <code style={{ color: "#f5741e" }}>{key}</code>
                                            <span className="excel-arrow">=</span>
                                            <span>{label as string}</span>
                                        </div>
                                    ))
                                )}
                            </div>


                            <div className="col-md-12">
                                <FileInput
                                    onCreate={(e) => {
                                        setBeanED({ ...beanED, Media: e.Media, MediaContext: e.MediaContext });
                                    }}
                                />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalUdatePlacas.modal} updateModal={modalUdatePlacas.setModal} eventModal={() => {
                        if (!beanED?.Media) {
                            toast.error("Archivo no valido")
                        } else {
                            updatePlatesImport();
                        }
                    }}>
                        <div className="row">
                            <div className="col-md-12">
                                <FileInput
                                    label="Archivo de Actualizacion de Placas"
                                    onCreate={(e) => {
                                        setBeanED({ ...beanED, Media: e.Media, MediaContext: e.MediaContext });
                                    }}
                                />
                            </div>
                            <div className="col-md-12">
                                <strong>Estructura del archivo (Excel con los siguientes campos en la primera fila):</strong>
                                <ul>
                                    <li><strong>ID:</strong> ID del Activo fijo</li>
                                    <li><strong>PLACA_NUEVA:</strong> Nueva placa del Activo fijo</li>
                                    <li><strong>SERIAL:</strong> Nuevo serial del Activo fijo</li>
                                    <li><strong>ESTADO:</strong> ID Nuevo estado del Activo fijo</li>
                                </ul>
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalListImages.modal} updateModal={modalListImages.setModal}>
                        <FixedAssetImages IdFixedAssetItem={bean.IDItem} />
                    </Modal>
                    <Modal modal={modalactivos} updateModal={setModalActivos} eventModal={editaItem}>
                        <div className="row">
                            <FixedAssetActiveHistoryByFixed idItem={bean.IDItem} />
                        </div>
                    </Modal>
                    <Modal modal={agregarresp} updateModal={setAgregarresp} eventModal={addFixedAssetitemToControlled}>
                        <div className="row">
                            <div className="col-md-6">
                                <InputDate label="Fecha Desde" name="from" value={bean.from} setDate={(e: any) => { setBean({ ...bean, 'from': e }) }} ></InputDate>
                            </div>
                            <div className="col-md-6">
                                <AccountEditor label="Responsable del activo" idAccount={bean.IDResponsible} onChange={(e) => { setBean({ ...bean, "IDResponsible": e.IDAccount }) }}></AccountEditor>
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={retiraractivo} updateModal={setRetiraractivo} eventModal={removeFixedAssetitemToControlled}>
                        <div className="row">
                            <div className="col-md-6">
                                <InputDate label="Fecha Desde" name="Desde" value={bean.from} setDate={(e: any) => { setBean({ ...bean, 'from': e }) }} ></InputDate>
                            </div>
                            <div className="col-md-6">
                                <FixedAssetItemStatesForDownloadItems idSelector={bean.itemDownCase} onChange={(e: any) => { setBean({ ...bean, 'itemDownCase': e }) }} />
                            </div>
                            <div className="col-md-12">

                                <label>Observaciones</label>
                                <textarea name="observations" className="form-control" value={bean.observations} onChange={handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Name}</strong>
                    </ModalConfirm>

                    {/* Mantenimientos opciones  */}

                    <Modal modal={modalHistory.modal} updateModal={modalHistory.setModal} >
                        <div className="row">
                            <div className="col-md-12">
                                <RequestMaintenance isModal filterProps={{ IDFixedAssetItem: bean.IDItem }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalReplacement.modal} updateModal={modalReplacement.setModal} >
                        <FixedAssetReplacement idItem={bean.IDItem} />
                    </Modal>

                    <Modal modal={modalWorkMaintenance.modal} updateModal={modalWorkMaintenance.setModal} >
                        <WorkMaintenanceOrderByItem idItem={bean.IDItem} />
                    </Modal>

                    <Modal modal={modalMaintenaceType.modal} updateModal={modalMaintenaceType.setModal} >
                        <AssignedMaintenanceType idItem={bean.IDItem} />
                    </Modal>

                    <Modal modal={modalCSV.modal} updateModal={modalCSV.setModal}>
                        <div className="row">
                            <div className="col">
                                {listaExport.length > 0 &&
                                    <ExportXLSL customName={"Activos Fijos"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaExport} onExport={(name: string) => {
                                        _single.download("formato xlsx [" + name + "] con " + listaExport.length + " registros");
                                    }} />
                                }
                            </div>
                        </div>
                    </Modal>

                </div>
            </div>
        )
    }

    return (
        <>
            {isModal
                ? bodyComponennt()
                : <BasicPage titulo="Historial de Activos Fijos">
                    {bodyComponennt()}
                </BasicPage>
            }
        </>
    );

}
